module.exports = __webpack_public_path__ + "assets/img/b0d45afad44b655a30a622ee4338839a.png";